import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DocumentComponent} from "./components/document.component";
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';

const routes = [{path:'document',
    component:DocumentComponent,
    canActivate:[CanActivateViaAuthGuard]}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class DocumentRoutingModule { }
